import getField from '@form/formGenerator'

export const loadCallsSaveUrl = `${import.meta.env.VITE_API_URL}/api/load-calls`

export const loadCallsFormObject = {
  type: null,
  csvFile: null
}

export const loadCallsFormFields = (loadCallsFormObject, updateFormObject, updateFormObjectProp, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'select',
      name: 'loadType',
      label: t('labels.load_type'),
      value: loadCallsFormObject.loadType,
      key: 'loadCallsFormObject-mairie',
      cssClass: 'column is-12',
      options: [{ label: t('labels.citizens'), value: 'citizen' }, { label: t('labels.companies'), value: 'company' }],
      required: true
    },
    {
      type: 'file',
      name: 'csvFile',
      blobPoster: loadCallsFormObject.csvFile ?? false,
      cssClass: 'column is-6 loadCallsFormObject-csvfile',
      simpleInput: false,
      key: 'loadCallsFormObject-csvfile',
      disabled: false,
      label: t('labels.csv_file'),
      targetUrl: `${import.meta.env.VITE_API_URL}/api/push/temp-files`,
      help: t('labels.csv_file_help'),
      fileType: 'sheet',
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.load'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'loadCallsFormObject-form',
      isLoading,
      disabled: 'undefined' === typeof loadCallsFormObject.csvFile || 'undefined' === typeof loadCallsFormObject.loadType
    }]

  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}